export interface CreateConfirmDialogOptions {
    width?: string | number;
    showCancel?: boolean;
    showFeedback?: boolean;
    persistent?: boolean;
}

export type CreateConfirmDialog = (title: string, content: string, options?: CreateConfirmDialogOptions) => Promise<boolean>;
export type CreateFeedbackDialog = (title: string, content: string, options?: CreateConfirmDialogOptions) => Promise<{ confirmed: boolean; feedback: string }>;

export const CreateConfirmDialogKey: InjectionKey<CreateConfirmDialog> = Symbol('CreateConfirmDialogKey');
export const CreateFeedbackDialogKey: InjectionKey<CreateFeedbackDialog> = Symbol('CreateFeedbackDialogKey');

export function useConfirmDialog() {
    const dialog = inject(CreateConfirmDialogKey);

    if (!dialog) {
        throw new Error('Could not resolve provider');
    }

    return dialog;
}
export function useFeedbackDialog() {
    const dialog = inject(CreateFeedbackDialogKey);

    if (!dialog) {
        throw new Error('Could not resolve provider');
    }

    return dialog;
}
